import { IGlobalState } from '../../../Root/store/appReducer'

export const getCompanyRanking = (state: IGlobalState) => state.companyRanking.companyRanking
export const getPeriodPercentage = (state: IGlobalState) => state.companyRanking.periodPercentage
export const getCompanyIsExcludedFromRanking = (state: IGlobalState) =>
  state.companyRanking.companyIsExcludedFromRanking
export const getCompanyRankingLoading = (state: IGlobalState) => state.companyRanking.companyRankingLoading
